import React from "react";
import "./Input.css";

const CustomInput = ({
  type = "text",
  onChange,
  value,
  error,
  maxLength,
  disabled = false,
  props,
  placeholder = "Type here",
  hintMessage,
  onPaste,
  onCopy,
  style,
  name,
}) => {
  const handleInputChange = (e) => {
    // Regex to match emojis in the input
    const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;

    // Remove emojis from the input value
    e.target.value = e.target.value.replace(emojiRegex, "");

    // Update the state with the sanitized value
    onChange(e);
  };

  const inputStyle = {
    ...style,
    width: style && style.width ? style.width : '100%'
  };

  return (
    <div>
      <input
        onCopy={onCopy}
        onPaste={onPaste}
        maxLength={maxLength}
        disabled={disabled}
        className={disabled ? "custom-input-disabled" : "custom-input"}
        value={value}
        type={type}
        spellCheck="false"
        autoComplete="off"
        aria-autocomplete="none"
        placeholder={disabled ? "" : placeholder}
        onChange={handleInputChange}
        style={inputStyle}
        name={name}
        {...props}
      />
      {/* TODO add the error message here */}
      {error && <div className="text-danger">{error}</div>}
      {hintMessage && (
        <div
          className="hintmessage"
          dangerouslySetInnerHTML={{ __html: hintMessage }}
        />
      )}
    </div>
  );
};

export default CustomInput;
